// Minimal top nav for the marketing landing. Consistent with the docs and
// dashboard headers (brand mark left, links right) but quieter — no project
// switchers, no status icons. Bare presence so visitors see Cairn's identity.

import { Link } from 'react-router-dom'

export function MarketingHeader() {
  return (
    <header className="sticky top-0 z-30 border-b border-[var(--color-sandstone)] bg-[var(--color-limestone)]/95 backdrop-blur">
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-6">
        <Link
          to="/"
          className="text-base font-medium tracking-tight text-[var(--color-terracotta)]"
        >
          cairn
        </Link>
        <nav className="flex items-center gap-5 text-sm text-[var(--color-slate)]">
          <Link to="/docs" className="hover:text-[var(--color-basalt)]">
            Docs
          </Link>
          <a
            href="https://github.com/cairntools/cairn"
            className="hover:text-[var(--color-basalt)]"
          >
            GitHub
          </a>
          <Link to="/auth/login" className="hover:text-[var(--color-basalt)]">
            Sign in
          </Link>
        </nav>
      </div>
    </header>
  )
}
